import { ENDPOINTS } from "../services/Endpoints";
export default {
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      headersImgs: [
        {
          title: "Imagem",
        },
        {
          title: "Url",
        },
        {
          title: "Ações",
        },
      ],
      headersPerguntas: [
        {
          title: "Ordem",
        },
        {
          title: "Pergunta",
        },
        {
          title: "Resposta",
        },
        {
          title: "Ações",
        },
      ],
      headersRedesSociais: [
        {
          title: "Ordem",
        },
        {
          title: "Descrição",
        },
        {
          title: "Link",
        },
        {
          title: "Ações",
        },
      ],
      headersContato: [
        {
          title: "Ordem",
        },
        {
          title: "Descrição",
        },
        {
          title: "Texto",
        },
        {
          title: "Ações",
        },
      ],
      headersPoliticas: [
        {
          title: "Descrição",
        },
        // {
        //     title: 'Conteúdo'
        // },
        {
          title: "Ações",
        },
      ],
    };
  },
  methods: {
    getImagem(file, imagem) {
      const self = this;
      if (file) {
        var reader = new FileReader();
        reader?.readAsDataURL(file);

        reader.onload = function () {
          switch (imagem) {
            case "logotipo":
              self.$marketplace.cadastro.logotipo.imagem = reader.result;
              break;
            case "banner":
              self.$marketplace.cadastro.imagem_upload.imagem = reader.result;
              break;
            case "logotipo_pos":
              self.$marketplace.cadastro.logotipo_pos.imagem = reader.result;
              break;
            default:
              self.$marketplace.cadastro.imagem_upload.imagem = reader.result;
              break;
          }
        };
        reader.onerror = function (error) {
          console.log("Error: ", error);
        };
      }
    },
    uploadImage(file, object) {
      if (object.size > 2000000) {
        this.$config.alert(
          "Tamanho máximo de imagem é de 2MB!",
          this.$config.dados.errorColor
        );
        return;
      }
      if (this.$marketplace.cadastro.imagem == "") {
        this.$config.alert(
          "Selecione o tipo de imagem!",
          this.$config.dados.errorColor
        );
        this.$marketplace.cadastro.error.imagem = "Selecione o tipo de imagem!";
        return;
      }

      this.$marketplace.cadastro.loading_imagem = true;
      this.$axios
        .post(this.ENDPOINTS.UPLOAD_BANNER_LOJA, {
          img_base64: file,
          idtema:
            this.$marketplace.configsPlusAdd == "new" &&
            this.$marketplace.cadastro.banners_array.length == 0
              ? ""
              : this.$produtos_gerenciar.cadastro.id_tema,
          loja: this.$axios.getLocal("oe_user_info")?.data?.loja || null,
        })
        .then(response => {
          if (response) {
            let object = {};

            if (
              this.$marketplace.configsPlusAdd == "new" &&
              this.$marketplace.cadastro.banners_array.length == 0
            ) {
              this.$marketplace.cadastro.idtema = response.idtema;
            }
            object[this.$marketplace.cadastro.imagem] = response.url;
            this.$marketplace.cadastro.banners_array.push(object);
            this.$marketplace.cadastro.loading_imagem = false;

            (this.$marketplace.cadastro.imagem = ""),
              (this.$marketplace.cadastro.imagem_upload.imagem = null);
            delete this.$marketplace.cadastro.imagem_upload.object;
          }
        })
        .catch(error => {
          this.$marketplace.cadastro.loading_imagem = false;
          throw new Error(error);
        });
    },
    previewImage(imagem) {
      document.getElementsByClassName(
        "modal-body-visualizar-imagem"
      )[0].style.display = "flex";
      this.$marketplace.visualizarImagem = imagem;
    },
    clearImage() {
      this.$marketplace.cadastro.imagem_upload.imagem = null;
    },
  },
  removerImagem(imagem) {
    switch (imagem) {
      case "logotipo":
        this.$marketplace.cadastro.logotipo.imagem = null;
        delete this.$marketplace.cadastro.logotipo.object;
        this.$marketplace.cadastro.logotipo.have = false;
        break;
      case "logotipo_pos":
        this.$marketplace.cadastro.logotipo_pos.imagem = null;
        delete this.$marketplace.cadastro.logotipo_pos.object;
        this.$marketplace.cadastro.logotipo_pos.have = false;
        break;
      default:
        this.$marketplace.cadastro.logotipo.imagem = null;
        delete this.$marketplace.cadastro.logotipo.object;
        this.$marketplace.cadastro.logotipo.have = false;
        break;
    }
  },
};
